import React from 'react'
import SkeletonComponent, { SkeletonTheme } from 'react-loading-skeleton'
import get from 'lodash/get'

import './styles.scss'

const themes = {
  default: {
    baseColor: '#EDF2F7',
    highlightColor: '#F7F9FB',
  },
  medium: {
    baseColor: '#E2E8F0',
    highlightColor: '#D1DCE6',
  },
  dark: {
    baseColor: '#2D3748',
    highlightColor: '#4A5568',
  },
}

const defaultTheme = 'default'

const allowedThemes = Object.keys(themes)

export const skeletonWrapper = ({ children }) => <div data-testid="skeleton">{children}</div>

const filterEmpty = (obj = {}) =>
  Object.keys(obj)
    .filter((key) => Boolean(obj[key]) || obj[key] === 0)
    .map((key) => ({ [key]: obj[key] }))
    .reduce((result, current) => ({ ...result, ...current }), {})

const Skeleton = (props) => {
  let theme = get(props, 'theme', defaultTheme)
  if (!allowedThemes.includes(theme)) {
    theme = defaultTheme
  }

  const { color, highlightColor } = props
  const themeProps = {
    ...themes[theme],
    ...filterEmpty({ baseColor: color, highlightColor }),
  }

  const { count, duration, width, wrapper, height, circle } = props
  const componentProps = filterEmpty({
    count,
    duration,
    width: Number.isInteger(width) ? `${width}px` : width,
    height: Number.isInteger(height) ? `${height}px` : height,
    wrapper,
    circle,
  })

  if (!Object.keys(themeProps).length) {
    return <SkeletonComponent {...componentProps} wrapper={skeletonWrapper} />
  }

  return (
    <SkeletonTheme {...themeProps}>
      <SkeletonComponent {...componentProps} wrapper={skeletonWrapper} />
    </SkeletonTheme>
  )
}

export default Skeleton
